exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[dir] .modal{text-align:center;padding:0!important}.modal:before{content:\"\";display:inline-block;height:100%;vertical-align:middle}[dir=ltr] .modal:before{margin-right:-4px}[dir=rtl] .modal:before{margin-left:-4px}.modal-dialog{display:inline-block;vertical-align:middle}[dir=ltr] .modal-dialog{text-align:left}[dir=rtl] .modal-dialog{text-align:right}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-76b4f5ec","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewOrderDetails.vue
// module id = 573
// module chunks = 0